import { render } from "./MenuSubitem.vue?vue&type=template&id=4372e468&scoped=true"
import script from "./MenuSubitem.vue?vue&type=script&lang=js"
export * from "./MenuSubitem.vue?vue&type=script&lang=js"

import "./MenuSubitem.vue?vue&type=style&index=0&id=4372e468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4372e468"]])

export default __exports__